<template>
	<div class="contacts_right friends_info">
		<div class="profile">
			<span class="user_photo AVATAR mb_20"></span>
			<p class="mb_20 fw_bold">아이디</p>
		</div>
		<p class="title">{{ $t('rtr_pay-contact.name') }}</p>
		<input type="text" class="w100 readonly" readonly />
		<p class="title">{{ $t('rtr_pay-contact.account') }}</p>
		<input type="text" class="w100 readonly" readonly />
		<p class="title">{{ $t('rtr_pay-contact.memo') }}</p>
		<textarea class="memo readonly" readonly></textarea>
		<div class="d_flex justify_between">
			<button class="small">{{ $t('button.send') }}</button>
			<button class="small red">
				{{ $t('button.receive_request') }}
			</button>
		</div>
		<div class="button_position">
			<button class="mr_5" disabled>
				{{ $t('button.delete') }}
			</button>
			<button class="mr_5" disabled>
				{{ $t('button.block') }}
			</button>
			<button disabled>{{ $t('button.edit1') }}</button>
		</div>
	</div>
</template>

<script>
export default {
	name: 'ContactsFriendsInfo',
};
</script>

<style scoped></style>
